enum ESortOrder {
  Ascending = 'asc',
  Descending = 'desc',
}

export default ESortOrder;
